module.exports = __webpack_public_path__ + "img/pleasure-icon-7.1c9697da.svg";